import React, { useState, useEffect } from 'react';
import Chart from 'react-apexcharts';

const BarChart = ({ chartData, chartOptions }) => {
  const [data, setData] = useState([]);
  const [options, setOptions] = useState({});

  useEffect(() => {
    setData(chartData);
    setOptions(chartOptions);
  }, [chartData, chartOptions]);


  const safeOptions = options && typeof options === "object" ? options : {};

  return (
      <Chart
          options={{
            ...safeOptions,
            chart: {
              ...(safeOptions.chart || {}),
              events: {
                ...(safeOptions.chart?.events || {}),
                mouseMove: (event, chartContext) => {
                  if (!chartContext?.w?.globals?.dom?.baseEl) return;
                  safeOptions.chart?.events?.mouseMove?.(event, chartContext);
                },
                mouseLeave: (event, chartContext) => {
                  if (!chartContext?.w?.globals?.dom?.baseEl) return;
                  safeOptions.chart?.events?.mouseLeave?.(event, chartContext);
                },
              },
            },
          }}
          series={Array.isArray(data) ? data : []}
          type="bar"
          width="100%"
          height="100%"
      />
  );
};

export default BarChart;
